/* Plated Nudges — coordinated conversion nudge system. All behaviour driven by theme settings. */
(function () {
  'use strict';
  var settingsEl = document.getElementById('plated-nudges-settings');
  if (!settingsEl) return;
  var S = {};
  try { S = JSON.parse(settingsEl.textContent); } catch (e) { return; }

  var isMobile = window.matchMedia('(max-width: 798px)').matches;
  var MAX_FLOATING = isMobile ? (S.max_mobile || 2) : (S.max_desktop || 3);
  var GAP_MS = (S.interval_seconds || 30) * 1000;

  var SS = window.sessionStorage, LS = window.localStorage;
  function sget(k, d) { try { var v = JSON.parse(SS.getItem('pn_' + k)); return v === null ? d : v; } catch (e) { return d; } }
  function sset(k, v) { try { SS.setItem('pn_' + k, JSON.stringify(v)); } catch (e) {} }
  function lget(k, d) { try { var v = JSON.parse(LS.getItem('pn_' + k)); return v === null ? d : v; } catch (e) { return d; } }
  function lset(k, v) { try { LS.setItem('pn_' + k, JSON.stringify(v)); } catch (e) {} }

  var shownCount = sget('count', 0);
  var shownNames = sget('shown', []);
  var lastClose = sget('lastclose', 0);
  var lastATC = sget('atc', 0);
  var checkoutStarted = sget('checkout', false);
  var subscribed = lget('subscribed', false);
  var visible = null;
  var queue = [];

  function track(nudge, action, extra) {
    var payload = { nudge: nudge, action: action, ts: Date.now() };
    if (extra) { for (var k in extra) payload[k] = extra[k]; }
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'plated_nudge' }, payload)); } catch (e) {}
    try { if (window.klaviyo && window.klaviyo.track) window.klaviyo.track('Plated Nudge', payload); } catch (e) {}
  }

  function isCheckoutContext() {
    if (checkoutStarted) return true;
    return /\/checkouts?\b/.test(window.location.pathname);
  }


  function foreignPopupOpen() {
    var els = document.querySelectorAll('[class*=klaviyo], [id*=klaviyo], [role="dialog"]');
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.closest('.pn-toast, .pn-modal-backdrop')) continue;
      if (String(e.className).indexOf('pn-') === 0) continue;
      var cs = window.getComputedStyle(e);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      if (e.offsetHeight < 60 || e.offsetWidth < 150) continue;
      if (cs.position === 'fixed' || cs.position === 'absolute' || cs.position === 'sticky' || e.getAttribute('role') === 'dialog') return true;
    }
    return false;
  }

  function canShow(name, opts) {
    opts = opts || {};
    if (!S[name + '_enable']) return false;
    if (visible) return false;
    if (shownCount >= MAX_FLOATING) return false;
    if (shownNames.indexOf(name) !== -1) return false;
    if (isCheckoutContext()) return false;
    if (foreignPopupOpen()) return false;
    var now = Date.now();
    if (now - lastClose < GAP_MS) return false;
    if (now - lastATC < GAP_MS) return false;
    if (opts.email && subscribed) return false;
    if (opts.email) {
      var d = lget('email_dismiss', 0);
      if (d && now - d < 7 * 864e5) return false;
    }
    return true;
  }

  function requestShow(name, builder, opts) {
    if (!canShow(name, opts)) return false;
    if (!visible) { doShow(name, builder, opts); return true; }
    return false;
  }

  function doShow(name, builder, opts) {
    var el = builder();
    if (!el) return;
    visible = { name: name, el: el };
    shownCount++; sset('count', shownCount);
    shownNames.push(name); sset('shown', shownNames);
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('pn-in'); });
    track(name, 'shown');
    el.querySelectorAll('[data-pn-close]').forEach(function (b) {
      b.addEventListener('click', function () { dismiss(name, el, opts); });
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') dismiss(name, el, opts); });
    el.querySelectorAll('[data-pn-cta]').forEach(function (b) {
      b.addEventListener('click', function () { track(name, 'clicked'); });
    });
  }

  function dismiss(name, el, opts) {
    el.classList.remove('pn-in');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 300);
    visible = null;
    lastClose = Date.now(); sset('lastclose', lastClose);
    track(name, 'dismissed');
    if (opts && opts.email) lset('email_dismiss', Date.now());
  }

  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function toastShell(name, inner) {
    return el('<div class="pn-toast pn-toast--' + name + '" role="status">' +
      '<button type="button" class="pn-close" data-pn-close aria-label="Dismiss">&times;</button>' + inner + '</div>');
  }

  /* ---- Email signup submit (Shopify customer form -> Klaviyo sync) ---- */
  function wireEmailForm(form, name, modalEl, opts) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = form.querySelector('input[type=email]').value.trim();
      if (!email) return;
      var btn = form.querySelector('button[type=submit]');
      btn.disabled = true;
      var body = 'form_type=customer&utf8=%E2%9C%93&contact%5Btags%5D=prospect%2Cnewsletter&contact%5Bemail%5D=' + encodeURIComponent(email);
      fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/javascript' }, body: body, credentials: 'same-origin' })
        .then(function () {
          subscribed = true; lset('subscribed', true);
          try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
          track(name, 'email_submitted');
          var success = modalEl.querySelector('[data-pn-success]');
          var main = modalEl.querySelector('[data-pn-main]');
          if (success && main) { main.setAttribute('hidden', ''); success.removeAttribute('hidden'); }
        })
        .catch(function () { btn.disabled = false; });
    });
  }

  function emailModal(name, heading, text, button, successText) {
    return function () {
      var m = el('<div class="pn-modal-backdrop pn-modal--' + name + '" role="dialog" aria-modal="true" aria-label="' + esc(heading) + '">' +
        '<div class="pn-modal">' +
        '<button type="button" class="pn-close" data-pn-close aria-label="Close">&times;</button>' +
        '<div data-pn-main><h3 class="pn-heading">' + esc(heading) + '</h3>' +
        '<p class="pn-text">' + esc(text) + '</p>' +
        '<form class="pn-form"><input type="email" required placeholder="Email address" aria-label="Email address" />' +
        '<button type="submit" class="pn-btn">' + esc(button) + '</button></form></div>' +
        '<div data-pn-success hidden><h3 class="pn-heading">' + esc(S.email_success_heading || 'You\u2019re in.') + '</h3>' +
        '<p class="pn-text">' + esc(successText) + '</p></div>' +
        '</div></div>');
      wireEmailForm(m.querySelector('form'), name, m, { email: true });
      return m;
    };
  }

  var isProduct = /\/products\//.test(window.location.pathname);
  var isCupPage = document.querySelector('.bundle-picker') !== null;

  /* ---- Nudge 1: email acquisition ---- */
  if (S.email_enable) {
    var emailShown = false;
    function tryEmail() {
      if (emailShown) return;
      if (requestShow('email', emailModal('email', S.email_heading, S.email_text, S.email_button, S.email_success), { email: true })) emailShown = true;
    }
    setTimeout(tryEmail, (S.email_delay || 13) * 1000);
    window.addEventListener('scroll', function onScroll() {
      var pct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
      if (pct >= (S.email_scroll || 40)) { tryEmail(); }
    }, { passive: true });
  }

  /* If a foreign popup (e.g. Klaviyo) opens while ours is visible, step aside. */
  setInterval(function () {
    if (visible && foreignPopupOpen()) { dismiss(visible.name, visible.el, {}); }
  }, 1500);

  /* ---- Nudge 9: desktop exit intent ---- */
  if (S.exit_enable && !isMobile) {
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !e.relatedTarget) {
        requestShow('exit', emailModal('exit', S.exit_heading, S.exit_text, S.exit_button, S.email_success), { email: true });
      }
    });
  }

  /* ---- Nudge 2: mix-and-match toast on cup product pages ---- */
  if (S.mix_enable && isCupPage) {
    setTimeout(function () {
      requestShow('mix', function () {
        return toastShell('mix', '<p class="pn-toast__heading">' + esc(S.mix_heading) + '</p><p class="pn-toast__text">' + esc(S.mix_text) + '</p>');
      });
    }, (S.mix_delay || 9) * 1000);
  }

  /* ---- Nudge 6: deep product browse ---- */
  if (S.deep_enable && isProduct) {
    window.addEventListener('scroll', function () {
      var pct = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
      if (pct >= (S.deep_scroll || 70)) {
        requestShow('deep', function () {
          return toastShell('deep', '<p class="pn-toast__heading">' + esc(S.deep_heading) + '</p><p class="pn-toast__text">' + esc(S.deep_text) + '</p>');
        });
      }
    }, { passive: true });
  }

  /* ---- Nudge 7: multiple colour/product browsing ---- */
  if (S.multi_enable && isProduct) {
    var views = sget('views', []);
    var handle = window.location.pathname.split('/products/')[1].split(/[?#]/)[0];
    if (views.indexOf(handle) === -1) { views.push(handle); sset('views', views); }
    var cupViews = views.filter(function (h) { return /cup|coffee-set|espresso/i.test(h); });
    if (views.length >= 3 || cupViews.length >= 2) {
      requestShow('multi', function () {
        return toastShell('multi', '<p class="pn-toast__heading">' + esc(S.multi_heading) + '</p><p class="pn-toast__text">' + esc(S.multi_text) + '</p>');
      });
    }
  }

  /* ---- Nudge 10: Broadway Market toast ---- */
  if (S.broadway_enable) {
    setTimeout(function () {
      requestShow('broadway', function () {
        return toastShell('broadway', '<p class="pn-toast__heading">' + esc(S.broadway_heading) + '</p><p class="pn-toast__text">' + esc(S.broadway_text) + '</p>');
      });
    }, (S.broadway_delay || 35) * 1000);
  }

  /* ---- Nudge 11: basket return reminder ---- */
  if (S.basket_enable) {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var hadItems = lget('had_items', false);
      lset('had_items', cart.item_count > 0);
      if (hadItems && cart.item_count > 0) {
        requestShow('basket', function () {
          return toastShell('basket', '<p class="pn-toast__heading">' + esc(S.basket_heading) + '</p><p class="pn-toast__text">' + esc(S.basket_text) + '</p>' +
            '<a class="pn-btn pn-btn--link" href="/cart" data-pn-cta>' + esc(S.basket_button || 'View basket') + '</a>');
        });
      }
    }).catch(function () {});
  }

  /* ---- Nudge 8: recently viewed (inline module) ---- */
  if (S.recent_enable && isProduct) {
    var rv = lget('recent', []);
    var cur = window.location.pathname.split('/products/')[1].split(/[?#]/)[0];
    rv = rv.filter(function (h) { return h !== cur; });
    var prior = rv.slice(0, 4);
    rv.unshift(cur); rv = rv.slice(0, 8); lset('recent', rv);
    var mount = document.querySelector('[data-pn-recent]');
    if (mount && prior.length) {
      var title = document.querySelector('.product-title, h1') ? document.querySelector('.product-title, h1').textContent.trim() : '';
      var jobs = prior.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      });
      Promise.all(jobs).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        var html = '<h3 class="pn-recent__heading">' + esc(S.recent_heading || 'Still thinking about it?') + '</h3><div class="pn-recent__grid">';
        products.forEach(function (p) {
          var img = p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[^.]+)$/, '_240x$1') + '" alt="' + esc(p.title) + '" loading="lazy" />' : '';
          var price = (p.price / 100).toFixed(2);
          html += '<a class="pn-recent__card" href="' + p.url + '" data-pn-cta>' + img + '<span class="pn-recent__title">' + esc(p.title) + '</span><span class="pn-recent__price">\u00A3' + price + '</span></a>';
        });
        html += '</div>';
        mount.innerHTML = html;
        var anchor = document.querySelector('[id*="__recommendations"]') || document.querySelector('[id*="__footer"]');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(mount, anchor);
        mount.removeAttribute('hidden');
        mount.querySelectorAll('[data-pn-cta]').forEach(function (a) { a.addEventListener('click', function () { track('recent', 'clicked'); }); });
        track('recent', 'shown');
      });
    }
  }

  /* ---- Global listeners: ATC + checkout suppression ---- */
  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart], .ajax-submit');
    if (atc) { lastATC = Date.now(); sset('atc', lastATC); if (visible) dismiss(visible.name, visible.el); }
    var co = e.target.closest && e.target.closest('[name="checkout"], [href*="/checkout"], .ajax-cart__checkout, [data-checkout]');
    if (co) { checkoutStarted = true; sset('checkout', true); if (visible) dismiss(visible.name, visible.el); }
  }, true);

  /* conversion attribution: nudge clicked then ATC within session */
  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart], .ajax-submit');
    if (atc && shownNames.length) track(shownNames[shownNames.length - 1], 'product_added_after_interaction');
  }, true);
})();
